export const routerjosn = {
    "content": [
        {
            "name": "home",
            "path": "/home",
            "meta": {
                "title": "首页",
                "icon": "el-icon-house",
                "type": "menu"
            },
            "children": [
                {
                    "name": "dashboard",
                    "path": "/dashboard",
                    "meta": {
                        "title": "控制台",
                        "icon": "el-icon-menu",
                        "affix": true
                    },
                    "component": "mallDashboard/index"
                },
                {
                    "name": "userCenter",
                    "path": "/usercenter",
                    "meta": {
                        "title": "帐号信息",
                        "icon": "el-icon-user",
                        "tag": "NEW"
                    },
                    "component": "userCenter/index"
                }
            ]
        },
        {
            "name": "activity",
            "path": "/activity",
            "meta": {
                "title": "营销管理",
                "icon": "el-icon-present",
            },
            "children": [
                {
                    "path": "/activity/coupon",
                    "name": "coupon",
                    "meta": {
                        "title": "优惠券",
                        "icon": "",
                    },
                    "children": [{
                        "path": "/activity/coupon/template",
                        "name": "coupontemplate",
                        "meta": {
                            "title": "模板管理",
                            "icon": "",
                        },
                        "component": "activity/coupon/template"
                    }, {
                        "path": "/activity/coupon/list",
                        "name": "couponlist",
                        "meta": {
                            "title": "发放列表",
                            "icon": "",
                        },
                        "component": "activity/coupon/list"
                    }, {
                        "path": "/activity/coupon/user",
                        "name": "couponuser",
                        "meta": {
                            "title": "发放记录",
                            "icon": "",
                        },
                        "component": "activity/coupon/user"
                    }]
                },
                {
                    "path": "/activity/group",
                    "name": "group",
                    "meta": {
                        "title": "拼团管理",
                        "icon": "",
                    },
                    "children": [{
                        "path": "/activity/group/config",
                        "name": "groupconfig",
                        "meta": {
                            "title": "拼团配置",
                            "icon": "",
                        },
                        "component": "activity/group/config"
                    }, {
                        "path": "/activity/group/list",
                        "name": "grouplist",
                        "meta": {
                            "title": "拼团列表",
                            "icon": "",
                        },
                        "component": "activity/group/list"
                    }, {
                        "path": "/activity/group/product",
                        "name": "groupproduct",
                        "meta": {
                            "title": "拼团商品",
                            "icon": "",
                        },
                        "component": "activity/group/product"
                    }]
                },
                {
                    "path": "/activity/integral",
                    "name": "integral",
                    "meta": {
                        "title": "积分商城",
                        "icon": "",
                    },
                    "children": [{
                        "path": "/activity/integral/product",
                        "name": "integralproduct",
                        "meta": {
                            "title": "积分商品",
                            "icon": "",
                        },
                        "component": "activity/integral/product"
                    }, {
                        "path": "/activity/integral/order",
                        "name": "integralorder",
                        "meta": {
                            "title": "积分订单",
                            "icon": "",
                        },
                        "component": "activity/integral/order"
                    }]
                },
                {
                    "path": "/activity/seckill",
                    "name": "seckill",
                    "meta": {
                        "title": "秒杀管理",
                        "icon": "",
                    },
                    "children": [{
                        "path": "/activity/seckill/product",
                        "name": "seckillproduct",
                        "meta": {
                            "title": "秒杀商品",
                            "icon": "",
                        },
                        "component": "activity/seckill/product"
                    }, {
                        "path": "/activity/seckill/time",
                        "name": "seckilltime",
                        "meta": {
                            "title": "秒杀时间",
                            "icon": "",
                        },
                        "component": "activity/seckill/time"
                    }]
                },
                {
                    "path": "/activity/bargain",
                    "name": "bargain",
                    "meta": {
                        "title": "砍价管理",
                        "icon": "",
                    },
                    "children": [{
                        "path": "/activity/bargain/product",
                        "name": "bargainproduct",
                        "meta": {
                            "title": "砍价商品",
                            "icon": "",
                        },
                        "component": "activity/bargain/product"
                    }, {
                        "path": "/activity/bargain/list",
                        "name": "bargainlist",
                        "meta": {
                            "title": "砍价列表",
                            "icon": "",
                        },
                        "component": "activity/bargain/list"
                    }, {
                        "path": "/activity/bargain/statistics",
                        "name": "bargainstatistics",
                        "meta": {
                            "title": "砍价统计",
                            "icon": "",
                            "hidden": true,
                        },
                        "component": "activity/bargain/statistics"
                    }]
                },
                {
                    "path": "/activity/lottery",
                    "name": "lottery",
                    "meta": {
                        "title": "抽奖管理",
                        "icon": "",
                    },
                    "children": [{
                        "path": "/activity/lottery/list",
                        "name": "lotterylist",
                        "meta": {
                            "title": "抽奖活动",
                            "icon": "",
                        },
                        "component": "activity/lottery/list"
                    }, {
                        "path": "/activity/lottery/record",
                        "name": "lotteryrecord",
                        "meta": {
                            "title": "中奖记录",
                            "icon": "",
                        },
                        "component": "activity/lottery/record"
                    }, {
                        "path": "/activity/lottery/config",
                        "name": "lotteryconfig",
                        "meta": {
                            "title": "抽奖配置",
                            "icon": "",
                        },
                        "component": "activity/lottery/config"
                    }, {
                        "path": "/activity/lottery/save",
                        "name": "lotterysave",
                        "meta": {
                            "title": "创建抽奖",
                            "icon": "",
                            "hidden": true,
                        },
                        "component": "activity/lottery/save"
                    }]
                }
            ]
        },
        {
            "name": "productManage",
            "path": "/productManage",
            "meta": {
                "title": "商品管理",
                "icon": "el-icon-shopping-bag",
                "type": "menu"
            },
            "children": [{
                "path": "/productManage/productList",
                "name": "productList",
                "meta": {
                    "title": "商品列表",
                    "icon": "",
                },
                "component": "productManage/productList"
            }, {
                "path": "/productManage/productComment",
                "name": "productComment",
                "meta": {
                    "title": "商品评论",
                    "icon": "",
                },
                "component": "productManage/productComment"
            }, {
                "path": "/productManage/productCategory",
                "name": "productCategory",
                "meta": {
                    "title": "商品分类",
                    "icon": "",
                },
                "component": "productManage/productCategory"
            }, {
                "path": "/productManage/productSuperHot",
                "name": "productSuperHot",
                "meta": {
                    "title": "爆款商品",
                    "icon": "",
                    // 隐藏：数据组 home_seckill_product 已无 C 端消费方（首页秒杀楼层由装修模板+秒杀场次驱动），避免误导运营
                    "hidden": true,
                },
                "component": "productManage/productSuperHot"
            }, {
                "path": "/productManage/productHotkeys",
                "name": "productHotkeys",
                "meta": {
                    "title": "热搜词",
                    "icon": "",
                },
                "component": "productManage/productHotkeys"
            }, {
                "path": "/productManage/productFreightTemplate",
                "name": "productFreightTemplate",
                "meta": {
                    "title": "运费模板",
                    "icon": "",
                },
                "component": "productManage/productFreightTemplate"
            },]
        },
        {
            "name": "user",
            "path": "/user",
            "meta": {
                "title": "商城用户",
                "icon": "el-icon-user",
                "type": "menu"
            },
            "children": [{
                "path": "/user/info",
                "name": "userInfo",
                "meta": {
                    "title": "用户列表",
                    "icon": "",
                },
                "component": "user/userInfo"
            }, {
                "path": "/user/wallet",
                "name": "userWallet",
                "meta": {
                    "title": "钱包明细",
                    "icon": "",
                },
                "component": "user/userWallet"
            }, {
                "path": "/user/vipLevel",
                "name": "vipLevel",
                "meta": {
                    "title": "会员等级",
                    "icon": "",
                },
                "children": [
                    {
                        "path": "/user/vipConfig",
                        "name": "vipConfig",
                        "meta": {
                            "title": "会员配置",
                            "icon": "",
                        },
                        "component": "user/vipLevel"
                    },
                    {
                        "path": "/user/LevelSeting",
                        "name": "LevelSeting",
                        "meta": {
                            "title": "等级设置",
                            "icon": "",
                        },
                        "component": "user/LevelSeting"
                    },
                    {
                        "path": "/user/list",
                        "name": "userList",
                        "meta": {
                            "hidden": true,
                            'avtive': '/user/LevelSeting',
                            "title": "购买记录",
                            "icon": "",
                        },
                        "component": "user/list"
                    }]
            }, {
                "path": "/user/recharge",
                "name": "userRecharge",
                "meta": {
                    "title": "用户充值",
                    "icon": "",
                },
                "children": [
                    {
                        "path": "/user/recharge/log",
                        "name": "userRechargeLog",
                        "meta": {
                            "title": "充值记录",
                            "icon": "",
                        },
                        "component": "user/recharge/log"
                    },
                    {
                        "path": "/user/recharge/package",
                        "name": "userRechargePackage",
                        "meta": {
                            "title": "充值套餐",
                            "icon": "",
                        },
                        "component": "user/recharge/package"
                    },
                    {
                        "path": "/user/recharge/set",
                        "name": "userRechargeSet",
                        "meta": {
                            "title": "充值设置",
                            "icon": "",
                        },
                        "component": "user/recharge/set"
                    }
                ]
            }, {
                "path": "/user/withdraw",
                "name": "userWithdraw",
                "meta": {
                    "title": "用户提现",
                    "icon": "",
                },
                "children": [
                    {
                        "path": "/user/withdraw/manage",
                        "name": "userWithdrawManage",
                        "meta": {
                            "title": "提现记录",
                            "icon": "",
                        },
                        "component": "user/withdraw/manage"
                    },
                    {
                        "path": "/user/withdraw/bind",
                        "name": "userWithdrawBind",
                        "meta": {
                            "title": "提现账户",
                            "icon": "",
                        },
                        "component": "user/withdraw/bind"
                    },
                    {
                        "path": "/user/withdraw/config",
                        "name": "userWithdrawConfig",
                        "meta": {
                            "title": "提现设置",
                            "icon": "",
                        },
                        "component": "user/withdraw/config"
                    }
                ]
            }]
        },
        {
            "name": "mall",
            "path": "/mall",
            "meta": {
                "title": "商城配置",
                "icon": "el-icon-box",
                "type": "menu"
            },
            "children": [{
                "path": "/mall/problem",
                "name": "mallProblem",
                "meta": {
                    "title": "常见问题",
                    "icon": "",
                },
                "component": "mall/problem"
            }, {
                "path": "/mall/scoreSet",
                "name": "scoreSet",
                "meta": {
                    "title": "积分设置",
                    "icon": "",
                },
                "component": "mall/scoreSet"
            }, {
                "path": "/mall/signinConfig",
                "name": "signinConfig",
                "meta": {
                    "title": "签到配置",
                    "icon": "",
                },
                "component": "mall/signinConfig"
            }, {
                "path": "/mall/signinRecord",
                "name": "signinRecord",
                "meta": {
                    "title": "签到记录",
                    "icon": "",
                },
                "component": "mall/signinRecord"
            }, {
                "path": "/mall/set",
                "name": "mallSet",
                "meta": {
                    "title": "全局配置",
                    "icon": "",
                },
                "component": "mall/set"
            }, {
                "path": "/mall/printer",
                "name": "mallPrinter",
                "meta": {
                    "title": "小票打印",
                    "icon": "",
                },
                "component": "plugin/xiaopiao"
            }]
        },
        {
            "path": "/appzx",
            "name": "appzx",
            "meta": {
                "title": "商城装修",
                "icon": "el-icon-Tools",
                "type": "menu"
            },
            "children": [
                {
                    "path": "/appzx/template",
                    "name": "appzxtemplate",
                    "meta": {
                        "title": "模板管理",
                        "icon": "el-icon-Tools",
                    },
                    "component": "appzx/template",
                }, {
                    "path": "/appzx/appzxdecorate",
                    "name": "appzxindex",
                    "meta": {
                        "title": "进入装修",
                        "icon": "el-icon-Tools",
                        "hidden": true
                    },
                    "component": "appzx/decorate",
                }, {
                    "name": "custompages",
                    "path": "/custompages",
                    "meta": {
                        "title": "自定义页面",
                        "icon": "el-icon-Tools",
                    },
                    "component": "appzx/custom"
                },]
        },
        {
            "name": "order",
            "path": "/order",
            "meta": {
                "title": "订单管理",
                "icon": "el-icon-list",
                "type": "menu"
            },
            "children": [{
                "path": "/order/list",
                "name": "orderList",
                "meta": {
                    "title": "订单列表",
                    "icon": "",
                },
                "component": "order/list"
            }, {
                "path": "/order/express",
                "name": "orderExpress",
                "meta": {
                    "title": "物流快递",
                    "icon": "",
                },
                "component": "order/express"
            }, {
                "path": "/order/config",
                "name": "orderConfig",
                "meta": {
                    "title": "订单配置",
                    "icon": "",
                },
                "component": "order/config"
            }, {
                "path": "/order/set",
                "name": "orderSet",
                "meta": {
                    "title": "物流设置",
                    "icon": "",
                },
                "component": "order/set"
            }]
        },
        {
            "name": "agreement",
            "path": "/agreement",
            "meta": {
                "title": "平台协议",
                "icon": "el-icon-document",
                "type": "menu"
            },
            "children": [{
                "path": "/agreement/UserExplain",
                "name": "UserExplain",
                "meta": {
                    "title": "用户服务协议",
                    "icon": "",
                },
                "component": "agreement/UserExplain"
            }, {
                "path": "/agreement/PrivacyExplain",
                "name": "PrivacyExplain",
                "meta": {
                    "title": "隐私政策",
                    "icon": "",
                },
                "component": "agreement/PrivacyExplain"
            }, {
                "path": "/agreement/WithdrawExplain",
                "name": "WithdrawExplain",
                "meta": {
                    "title": "提现说明",
                    "icon": "",
                },
                "component": "agreement/WithdrawExplain"
            }, {
                "path": "/agreement/ScoreExplain",
                "name": "ScoreExplain",
                "meta": {
                    "title": "积分说明",
                    "icon": "",
                },
                "component": "agreement/ScoreExplain"
            }, {
                "path": "/agreement/DiscountCouponExplain",
                "name": "DiscountCouponExplain",
                "meta": {
                    "title": "优惠券说明",
                    "icon": "",
                },
                "component": "agreement/DiscountCouponExplain"
            }, {
                "path": "/agreement/PromotionExplain",
                "name": "PromotionExplain",
                "meta": {
                    "title": "推广说明",
                    "icon": "",
                },
                "component": "agreement/PromotionExplain"
            }]
        },
        {
            "name": "shopManage",
            "path": "/shopManage",
            "meta": {
                "title": "门店管理",
                "icon": "el-icon-goods",
                "type": "menu"
            },
            "children": [{
                "path": "/shopManage/verification",
                "name": "verification",
                "meta": {
                    "title": "核销员管理",
                    "icon": "",
                },
                "component": "shopManage/verification"
            }, {
                "path": "/shopManage/shopList",
                "name": "shopList",
                "meta": {
                    "title": "门店列表",
                    "icon": "",
                },
                "component": "shopManage/shopList"
            }, {
                "path": "/shopManage/shopVerificationList",
                "name": "shopVerificationList",
                "meta": {
                    "title": "门店核销员",
                    "icon": "",
                    "hidden": true
                },
                "component": "shopManage/shopVerificationList"
            }, {
                "path": "/shopManage/verificationOrder",
                "name": "verificationOrder",
                "meta": {
                    "title": "核销订单",
                    "icon": "",
                },
                "component": "shopManage/verificationOrder"
            }, {
                "path": "/shopManage/shopConfig",
                "name": "shopConfig",
                "meta": {
                    "title": "门店配置",
                    "icon": "",
                },
                "component": "shopManage/shopConfig"
            }]
        },
        {
            "name": "article",
            "path": "/article",
            "meta": {
                "title": "内容管理",
                "icon": "el-icon-files",
                "type": "menu"
            },
            "children": [{
                "path": "/article/category",
                "name": "articlecategory",
                "meta": {
                    "title": "文章分类",
                    "icon": "",
                },
                "component": "article/category"
            }, {
                "path": "/article/list",
                "name": "articlelist",
                "meta": {
                    "title": "文章列表",
                    "icon": "",
                },
                "component": "article/list"
            }, {
                "path": "/article/feedback",
                "name": "articlefeedback",
                "meta": {
                    "title": "意见反馈",
                    "icon": "",
                },
                "component": "article/feedback"
            }, {
                "name": "path",
                "path": "/pathGroup",
                "meta": {
                    "title": "页面分类",
                    "icon": "",
                },
                "component": "path/pathGroup"
            },
            {
                "name": "pathindex",
                "path": "/path",
                "meta": {
                    "title": "页面链接",
                    "icon": "",
                },
                "component": "path/index"
            }]
        },
        {
            "name": "distribution",
            "path": "/distribution",
            "meta": {
                "title": "分销管理",
                "icon": "el-icon-avatar",
                "type": "menu"
            },
            "children": [{
                "path": "/distribution/user",
                "name": "distributionuser",
                "meta": {
                    "title": "分销员管理",
                    "icon": "",
                },
                "component": "distribution/user"
            }, {
                "path": "/distribution/tgbg",
                "name": "distributiontgbg",
                "meta": {
                    "title": "推广海报",
                    "icon": "",
                },
                "component": "distribution/tgbg"
            }, {
                "path": "/distribution/config",
                "name": "distributionconfig",
                "meta": {
                    "title": "分销配置",
                    "icon": "",
                },
                "component": "distribution/config"
            }, {
                "path": "/distribution/promotion",
                "name": "distributionpromotion",
                "meta": {
                    "title": "推广下级",
                    "icon": "",
                    "hidden": true
                },
                "component": "distribution/promotion"
            }, {
                "path": "/distribution/order",
                "name": "distributionorder",
                "meta": {
                    "title": "分销订单统计",
                    "icon": "",
                    "hidden": true
                },
                "component": "distribution/order"
            }, {
                "path": "/distribution/Qrcode",
                "name": "distributionQrcode",
                "meta": {
                    "title": "推广码",
                    "icon": "",
                    "hidden": true
                },
                "component": "distribution/Qrcode"
            }]
        },
        {
            "name": "plugin",
            "path": "/plugin",
            "meta": {
                "title": "应用插件",
                "icon": "el-icon-eleme-filled",
                "type": "menu",
                "hidden": true
            },
            "children": [
                {
                    "path": "/plugin/index",
                    "name": "pluginindex",
                    "meta": {
                        "title": "插件列表",
                        "icon": "",
                    },
                    "component": "plugin/index"
                }, {
                    "path": "/plugin/wxzhibo",
                    "name": "pluginwxzhibo",
                    "meta": {
                        "title": "微信小程序直播管理",
                        "icon": "",
                        "hidden": true
                    },
                    "component": "plugin/wxzhibo"
            }]
        },
        {
            "name": "appset",
            "path": "/appset",
            "meta": {
                "title": "应用设置",
                "icon": "el-icon-setting",
                "type": "menu"
            },
            "children": [{
                "path": "/appset/official",
                "name": "appsetofficial",
                "meta": {
                    "title": "公众号",
                    "icon": "",
                },
            "children": [{
                "path": "/appset/officialConfig",
                "name": "appsetofficialConfig",
                "meta": {
                    "title": "公众号配置",
                    "icon": "",
                },
                "component": "appset/officialConfig"
            }, {
                "path": "/appset/officialMenu",
                "name": "officialmenu",
                    "meta": {
                        "title": "公众号菜单",
                        "icon": "",
                    },
                    "component": "appset/officialMenu"
                }, {
                    "path": "/appset/material",
                    "name": "material",
                    "meta": {
                        "title": "微信图文管理",
                        "icon": "",
                    },
                    "component": "appset/material"
                }, {
                    "path": "/appset/hfconfig",
                    "name": "hfconfig",
                    "meta": {
                        "title": "关注回复配置",
                        "icon": "",
                    },
                    "component": "appset/hfconfig"
                }, {
                    "path": "/appset/rule",
                    "name": "appsetrule",
                    "meta": {
                        "title": "回复规则管理",
                        "icon": "",
                    },
                    "component": "appset/rule"
                }]
            }, {
                "path": "/appset/miniapp",
                "name": "appsetminiapp",
                "meta": {
                    "title": "小程序配置",
                    "icon": "",
                },
                "component": "appset/miniapp"
            }, {
                "path": "/appset/message",
                "name": "appsetmessage",
                "meta": {
                    "title": "消息管理",
                    "icon": "",
                },
                "children": [{
                    "path": "/appset/xiaoxi",
                    "name": "appsetxiaoxi",
                    "meta": {
                        "title": "订阅消息",
                        "icon": "",
                    },
                    "component": "appset/xiaoxi"
                }, {
                    "path": "/appset/send",
                    "name": "send",
                    "meta": {
                        "title": "订阅消息发送记录",
                        "icon": "",
                    },
                    "component": "appset/send"
                }]
            }, {
                "path": "/appset/app",
                "name": "appsetapp",
                "meta": {
                    "title": "app菜单",
                    "icon": "",
                },
                "children": [{
                    "path": "/appset/appVersion",
                    "name": "appsetappVersion",
                    "meta": {
                        "title": "APP版本管理",
                        "icon": "",
                    },
                    "component": "appset/appVersion"
                }, {
                    "path": "/appset/appConfig",
                    "name": "appsetappConfig",
                    "meta": {
                        "title": "APP配置",
                        "icon": "",
                    },
                    "component": "appset/appConfig"
                }]
            }, {
                "path": "/appset/about",
                "name": "appsetabout",
                "meta": {
                    "title": "关于应用",
                    "icon": "",
                    "hidden": true,
                },
                "component": "appset/about"
            }, {
                "path": "/appset/system",
                "name": "appsetsystem",
                "meta": {
                    "title": "存储设置",
                    "icon": "",
                },
                "component": "appset/system"
            }, {
                "path": "/appset/sms",
                "name": "appsetsms",
                "meta": {
                    "title": "短信设置",
                    "icon": "",
                },
                "component": "appset/sms"
            }, {
                "path": "/appset/timerTask",
                "name": "appsettimerTask",
                "meta": {
                    "title": "定时任务",
                    "icon": "",
                },
                "component": "appset/timerTask"
            }, {
                "path": "/appset/customEvent",
                "name": "appsetcustomEvent",
                "meta": {
                    "title": "自定义事件",
                    "icon": "",
                },
                "component": "appset/customEvent"
            }, {
                "path": "/appset/systemFile",
                "name": "appsetsystemFile",
                "meta": {
                    "title": "文件管理",
                    "icon": "",
                },
                "component": "appset/systemFile"
            }, {
                "path": "/appset/databaseBackup",
                "name": "appsetdatabaseBackup",
                "meta": {
                    "title": "数据库备份",
                    "icon": "",
                },
                "component": "appset/databaseBackup"
            }, {
                "path": "/appset/codeGeneration",
                "name": "appsetcodeGeneration",
                "meta": { "title": "代码生成", "icon": "" },
                "component": "appset/codeGeneration/index"
            }, {
                "path": "/appset/dataDictionary",
                "name": "appsetDataDictionary",
                "meta": { "title": "数据字典", "icon": "" },
                "component": "appset/dataDictionary/index"
            }, {
                "path": "/appset/payConfig",
                "name": "appsetpayConfig",
                "meta": { "title": "支付配置", "icon": "" },
                "component": "appset/payConfig"
            }, {
                "path": "/appset/cityData",
                "name": "appsetcityData",
                "meta": { "title": "城市数据", "icon": "" },
                "component": "appset/cityData"
            }, {
                "path": "/appset/accessory",
                "name": "appsetaccessory",
                "meta": { "title": "附件管理", "icon": "" },
                "component": "appset/accessory"
            }, {
                "path": "/develop/classify",
                "name": "developclassify",
                "meta": { "title": "配置分类管理", "icon": "" },
                "component": "develop/classify"
            }, {
                "path": "/develop/developdata",
                "name": "developdata",
                "meta": { "title": "数据组管理", "icon": "" },
                "component": "develop/developdata"
            }]
        }, {
            "name": "node",
            "path": "/node",
            "meta": {
                "title": "权限管理",
                "icon": "el-icon-lock",
                "type": "menu"
            },
            "children": [{
                "path": "/node/menus",
                "name": "menus",
                "meta": { "title": "菜单管理", "icon": "mn-icon-code" },
                "component": "node/menus"
            }, {
                "path": "/node/roleindex",
                "name": "roleindex",
                "meta": { "title": "角色管理", "icon": "el-icon-user" },
                "component": "node/roleindex"
            }, {
                "path": "/node/loginuser",
                "name": "loginuser",
                "meta": { "title": "管理员管理", "icon": "el-icon-userFilled" },
                "component": "node/loginuser"
            }]
        }
        // ,{
        //     "name":"appzxdecorate",
        //     "path":"/childrenApp/appzx/decorate",
        //     "meta":{
        //         "title":"新页面装修",
        //         "icon":"el-icon-Tools",
        //         "type":"menu"
        //     },
        //     "component":"appzx/decorate"
        // }
    ]
}

